import Button from '../../shared/Button.jsx';

const summaryItems = ['1 risk identified', '1 task created to mitigate it'];

export default function CompleteStep({ onStartPart2 }) {
  return (
    <div>
      <h2
        style={{
          fontSize: 22,
          fontWeight: 700,
          color: 'var(--fg)',
          marginBottom: 20,
          fontFamily: 'var(--font-display)',
        }}
      >
        You've just done compliance
      </h2>

      <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 20px 0' }}>
        {summaryItems.map((item, i) => (
          <li
            key={i}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              padding: '10px 14px',
              marginBottom: 8,
              background: 'var(--accent-subtle)',
              border: '1px solid var(--accent-border2)',
              borderRadius: 8,
              fontSize: 14,
              color: 'var(--fg)',
            }}
          >
            <span style={{ color: 'var(--accent)', fontWeight: 700, fontSize: 16 }}>&#x2713;</span>
            {item}
          </li>
        ))}
      </ul>

      <p style={{ fontSize: 14, color: 'var(--fg2)', lineHeight: 1.75, marginBottom: 24 }}>
        When your team completes the task and adds evidence, Tryggr will reflect that the risk is
        being actively managed. That's the compliance loop. You can build on this — more documents,
        more risks, more controls. But you already understand how it works. Press Finish to go to
        your dashboard.
      </p>

      {/* Part 2 prompt */}
      <div
        style={{
          padding: '16px 20px',
          borderRadius: 10,
          marginBottom: 0,
          background: 'var(--bg3)',
          border: '1px solid var(--border)',
        }}
      >
        <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--fg)', marginBottom: 6 }}>
          Ready for Part 2?
        </div>
        <p style={{ fontSize: 13, color: 'var(--fg3)', lineHeight: 1.6, margin: '0 0 12px 0' }}>
          Learn how Tryggr manages the employee lifecycle — onboarding joiners, transferring movers,
          and offboarding leavers with checklists, assets, and evaluations.
        </p>
        <Button size="sm" onClick={onStartPart2}>
          Start Part 2
        </Button>
      </div>
    </div>
  );
}
